import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Skeleton } from '../../components/ui/skeleton';
import { Coins, Copy, Check, ArrowSquareOut, Link, CircleNotch } from '@phosphor-icons/react';

export function BalanceCard({ user, balanceInfo, loading, copied, copyAddress }) {
    const truncateAddress = (addr) => addr ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : '';
    return (
        <Card className="glass-card border-neon-gold/20 bg-neon-gold/5 box-glow-gold mb-6">
            <CardContent className="p-6">
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <span className="label-text text-neon-gold">IN-APP BALANCE</span>
                        {loading ? <Skeleton className="h-12 w-32 mt-2 bg-white/10" /> : (
                            <p className="stat-number text-neon-gold text-glow-gold mt-2" data-testid="rmr-balance">
                                {balanceInfo?.inAppBalance?.toFixed(2) || user?.boltz_balance?.toFixed(2) || '0.00'}
                            </p>
                        )}
                        <p className="text-sm text-muted-foreground mt-1">Boltz Coins</p>
                    </div>
                    <div className="w-16 h-16 bg-neon-gold/20 rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(255,215,0,0.2)]">
                        <Coins size={32} className="text-neon-gold" weight="fill" />
                    </div>
                </div>
                {user?.wallet_address ? (
                    <div className="bg-white/5 rounded-xl p-4 neon-border">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-xs text-muted-foreground">Connected Wallet</p>
                                <p className="font-mono text-sm mt-1 text-foreground">{truncateAddress(user.wallet_address)}</p>
                            </div>
                            <div className="flex gap-2">
                                <Button size="icon" variant="ghost" className="text-foreground hover:bg-white/10" onClick={copyAddress} data-testid="copy-address-btn">
                                    {copied ? <Check size={18} /> : <Copy size={18} />}
                                </Button>
                                <Button size="icon" variant="ghost" className="text-foreground hover:bg-white/10"
                                    onClick={() => window.open(`https://explorer.solana.com/address/${user.wallet_address}?cluster=devnet`, '_blank')} data-testid="view-explorer-btn">
                                    <ArrowSquareOut size={18} />
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : <p className="text-sm text-muted-foreground">Link your Solana wallet to mint tokens on-chain</p>}
            </CardContent>
        </Card>
    );
}

export function LinkWallet({ walletAddress, setWalletAddress, linking, linkWallet }) {
    return (
        <Card className="glass-card mb-6">
            <CardHeader><CardTitle className="flex items-center gap-2"><Link size={20} />Link Solana Wallet</CardTitle></CardHeader>
            <CardContent className="space-y-4">
                <div>
                    <Label htmlFor="wallet">Wallet Address</Label>
                    <Input id="wallet" value={walletAddress} onChange={(e) => setWalletAddress(e.target.value)} placeholder="Enter your Solana wallet address" className="font-mono text-sm" data-testid="wallet-address-input" />
                </div>
                <Button onClick={linkWallet} disabled={linking} className="w-full btn-primary" data-testid="link-wallet-btn">
                    {linking ? <><CircleNotch size={18} className="animate-spin mr-2" />Linking...</> : <><Link size={18} className="mr-2" />Link Wallet</>}
                </Button>
            </CardContent>
        </Card>
    );
}
